import { Injectable, Injector } from '@angular/core';
import { HttpBackend, HttpClient, HTTP_INTERCEPTORS } from '@angular/common/http';

import { InterceptingHandler } from '../base/core/intercepting-handler';
import { TOTARA_HTTP_INTERCEPTORS } from './totara-http-interceptors.token';

@Injectable()
export class TotaraHttpClient extends HttpClient {
  constructor(backend: HttpBackend, injector: Injector) {
    super(new InterceptingHandler(backend, injector, [HTTP_INTERCEPTORS, TOTARA_HTTP_INTERCEPTORS]));
  }
}
